<template>

	<form class="col-7 margin-b-100 order" @submit.prevent="submitDelivery">

		<header class="col-12 margin-b-50 padding-b-50 border-b">

			<h1>Levering</h1>

			<p>Nedenfor kan du vælge om du ønsker levering eller selv vil hente.</p>

			<br>

			<a href="https://wiki.naesbyhovedskov.dk/levering/" target="_blank">Se leveringsområder og priser her</a>

		</header>

		<section class="col-12 content margin-b-75 padding-b-75 border-b">

			<section class="row margin-b-50">

				<section class="radio-select-order margin-b-25">

					<label dusk="should-not-deliver">

						<section class="radio">

							<input type="radio" checked="checked" name="deliver" :value="false" v-model="delivery.with_delivery">

							<span class="checkmark-radio"></span>

						</section>

						<section class="text">
							<p>Henter selv</p>
							<p>Afhentes på Kanalvej 52, 5000 Odense C</p>
						</section>

					</label>

				</section>

				<section class="radio-select-order">

					<label dusk="should-deliver">

						<section class="radio">

							<input type="radio" name="deliver" :value="true" v-model="delivery.with_delivery">

							<span class="checkmark-radio"></span>

						</section>

						<section class="text">
							<p>Ønsker levering</p>
							<p>Ordren bliver leveret til den angivet adresse</p>
						</section>

					</label>

				</section>

			</section>

			<section class="row">

				<header class="header margin-b-50">

					<h1>Dato / tid</h1>

					<p>Vær opmærksom på, at du skal bestille min. 8 dage før dit arrangement.</p>

				</header>

				<section class="row">

					<section class="col-12 margin-b-75">

						<label v-if="delivery.with_delivery">Dato for levering?</label>

						<label v-else>Dato for afhentning?</label>

						<section class="input-group">

							<input class="col-12" type="text" placeholder="f.eks. 12-08-2018" name="date"  @click.prevent="showDatePicker" readonly :value="deliveryDate | moment('DD-MM-YYYY')" dusk="delivery-date">

							<span class="checkmark-order" v-if="dateValidated">

								<i class="icon--sm green fas fa-check-circle"></i>

							</span>

							<span class="checkmark-order" v-if="!dateValidated && hasEnteredDate">

								<i class="icon--sm icon--red fas fa-check-circle"></i>

							</span>

						</section>

					</section>

					<section class="col-12">

						<section class="input-group">

							<label v-if="delivery.with_delivery">Tidspunkt for levering?</label>

							<label v-else>Tidspunkt for afhentning?</label>

							<ws-select :options="deliveryTimes" v-model="deliveryTime" emptytext="Vælg tidspunkt" :select-by-value="true" @change="enteredField('time')" :use-null="true" :disabled="lockTimeSelector" dusk="delivery-time"></ws-select>

						</section>

					</section>

				</section>

			</section>

			<transition name="fade">

				<section v-if="delivery.with_delivery">

					<section class="row margin-b-50">

						<header class="header margin-tb-50">

							<h1>Bemærkninger til levering</h1>

							<p>F.eks. må gerne stilles i garagen, døren er åben.</p>

						</header>

						<section class="col-12">

							<textarea class="col-12" placeholder="f.eks. må afleveres på trappen" name="delivery_notes" v-model="delivery.delivery_notes"></textarea>

						</section>

					</section>

					<section class="row">

						<header class="header margin-b-50">

							<h1>Leveringsadresse</h1>

							<p>Din angivet leveringsadresse. Skal vi levere til en alternativ leveringsadresse, klik på knappen nedenfor.</p>

                            <template v-if="!canDeliver">
                                <p class="margin-t-50" ><strong>Bemærk! Der kan ikke leveres til den valgte adresse</strong></p>
                                <a href="https://wiki.naesbyhovedskov.dk/levering/" target="_blank">Se leveringsområder og priser her</a></p>
                            </template>

						</header>

						<transition name="fade" mode="out-in">

							<section class="col-12" v-if="!useAlternateAddress">

								<section class="col-12 margin-b-50">

									<ul>
										<li>{{order.information.firstname}} {{order.information.lastname}}</li>
										<li>{{order.information.address}}</li>
										<li>{{order.information.zipcode}} {{order.information.city}}</li>
										<li>{{order.information.phone}}</li>
										<li>{{order.information.email}}</li>
									</ul>

								</section>

								<section class="col-12">

									<a class="btn--secondary" href="#" @click.prevent="useAlternateAddress = true" v-if="!useAlternateAddress" dusk="use-alternate-address">Alternativ leveringsadresse</a>

								</section>

							</section>

							<section class="col-12" v-else>

								<section class="row margin-b-75">

									<a class="icon--black pull-right" href="#" @click.prevent="closeAndResetAlternateAddress" dusk="close-alternate-address"><i class="icon--lg fas fa-times"></i></a>

								</section>

								<section class="row">

									<section class="col-12 margin-b-75">

										<label>Hvad er dit fornavn?</label>

										<section class="input-group">

											<input class="col-12" type="text" placeholder="f.eks. søren" name="firstname"
												   v-model="delivery.information.firstname" @blur="enteredField('firstname')">

											<span class="checkmark-order" v-if="firstNameValidated">

											<i class="icon--sm green fas fa-check-circle"></i>

										</span>

											<span class="checkmark-order" v-if="!firstNameValidated && hasEnteredFirstName">

											<i class="icon--sm icon--red fas fa-check-circle"></i>

										</span>

										</section>

									</section>

									<section class="col-12 margin-b-75">

										<label>Hvad er dit efternavn?</label>

										<section class="input-group">

											<input class="col-12" type="text" placeholder="f.eks. hansen" name="lastname"
												   v-model="delivery.information.lastname" @blur="enteredField('lastname')">

											<span class="checkmark-order" v-if="lastNameValidated">

										  <i class="icon--sm green fas fa-check-circle"></i>

										</span>

											<span class="checkmark-order" v-if="!lastNameValidated && hasEnteredLastName">

											  <i class="icon--sm icon--red fas fa-check-circle"></i>

										</span>

										</section>

									</section>

								</section>

								<section class="row margin-b-75">

									<label>Hvad er din adresse?</label>

									<section class="input-group">

										<input class="col-12" type="text" placeholder="f.eks. kanalvej 52" name="address"
											   v-model="delivery.information.address" @blur="enteredField('address')">

										<span class="checkmark-order" v-if="addressValidated">

										 <i class="icon--sm green fas fa-check-circle"></i>

									 </span>

										<span class="checkmark-order" v-if="!addressValidated && hasEnteredAddress">

										<i class="icon--sm icon--red fas fa-check-circle"></i>

									</span>

									</section>

								</section>

								<section class="row">

									<section class="col-12 margin-b-75">

										<label>Hvad er dit postnummer?</label>

										<section class="input-group">

											<input class="col-12" type="tel" placeholder="f.eks. 5000" name="zipcode" id="zipcode"
												   min="1000" max="9999" maxlength="4" v-model="delivery.information.zipcode"
												   @blur="enteredField('zip')">

											<span class="checkmark-order" v-if="zipCodeValidated">

											<i class="icon--sm green fas fa-check-circle"></i>

										</span>

											<span class="checkmark-order" v-if="!zipCodeValidated && hasEnteredZip">

											<i class="icon--sm green fas fa-check-circle"></i>

										</span>

										</section>

									</section>

									<section class="col-12 margin-b-75">

										<label>Hvilken by bor du i?</label>

										<section class="input-group">

											<input class="col-12" type="text" placeholder="f.eks. odense c" name="city"
												   v-model="delivery.information.city" @blur="enteredField('city')">

											<span class="checkmark-order" v-if="cityValidated">

											<i class="icon--sm green fas fa-check-circle"></i>

										</span>

											<span class="checkmark-order" v-if="!cityValidated && hasEnteredCity">

											<i class="icon--sm icon--red fas fa-check-circle"></i>

										</span>

										</section>

									</section>

								</section>

								<section class="row">

									<section class="col-12 margin-b-75">

										<label>Hvad er din e-mail adresse?</label>

										<section class="input-group">

											<input class="col-12" type="email" placeholder="f.eks. ole@hansen.dk" name="email"
												   v-model="delivery.information.email" @blur="enteredField('email')">

											<span class="checkmark-order" v-if="emailValidated">

											<i class="icon--sm green fas fa-check-circle"></i>

										</span>

											<span class="checkmark-order" v-if="!emailValidated && hasEnteredEmail">

											<i class="icon--sm icon--red fas fa-check-circle"></i>

										</span>

										</section>

									</section>

									<section class="col-12 margin-b-75">

										<label>Hvad er dit telefonummer?</label>

										<section class="input-group">

											<input class="col-12" type="number" placeholder="f.eks. 62717181" name="phone"
												   v-model="delivery.information.phone" @blur="enteredField('phone')">

											<span class="checkmark-order" v-if="phoneValidated">

											<i class="icon--sm green fas fa-check-circle"></i>

										</span>

											<span class="checkmark-order" v-if="!phoneValidated && hasEnteredPhone">

											<i class="icon--sm icon--red fas fa-check-circle"></i>

										</span>

										</section>

									</section>

								</section>

							</section>

						</transition>

					</section>

				</section>

			</transition>


		</section>

		<section class="col-12 content margin-b-75 padding-b-75 border-b">

			<section class="col-12">

				<h1>Leveringspris</h1>

				<h3>Samlet pris  <span>{{stripeAmount(deliveryFee).amount}},-</span></h3>

			</section>

		</section>

		<section class="col-12 flex--space">

			<router-link :to="{name:'make-order.order.information'}">Tilbage</router-link>

			<button type="submit" class="btn--primary btn--sm primary--copper" :class="{'disabled':!allInformationValidated}" :disabled="!allInformationValidated" dusk="delivery-done">
				Gå til Betaling
			</button>

		</section>

		<ws-modal v-model="showDatePickerModal">

			<article class="modal-wrap">

				<section class="modal--sm center">

					<span class="close" @click.prevent="datePickerReset"><i class="fas fa-times"></i></span>

					<section class="datepicker-trigger" id="datepicker-trigger">
						<AirbnbStyleDatepicker
								:trigger-element-id="'datepicker-trigger'"
								:inline="true"
								:mode="'single'"
								:date-one="datePickerDate"
								:showActionButtons="false"
								:monthsToShow="1"
								:min-date="canGetDeliveryFrom"
								@date-one-selected="setDeliveryDate"
								:end-date="endDate"
						/>
					</section>

				</section>

			</article>

		</ws-modal>

	</form>

</template>

<script>
	import {mapGetters} from 'vuex';
    import fetchCityByZip from './../mixins/fetchCityByZip.js';
    import moment from 'moment';
    export default {
        name: "delivery",
		data(){
          	return {
          	  	deliveryDate:null,
                deliveryTime:null,
                datePickerDate:null,
				useAlternateAddress:false,
				city:'',
                enteredFields: [],
				showDatePickerModal:false,
			};
		},
        mixins:[fetchCityByZip],
        watch:{
            delivery:{
                handler(value){
                    this.$store.dispatch('productless/setDelivery', value);
                },
                deep:true,
            },

        },
		computed:{
			...mapGetters({
				order:'productless/order',
                zipcodes:'delivery_zipcodes',
			}),
			delivery:{
			    get(){
			        return this.order.delivery;
				},
				set(value){
			        this.$store.dispatch('productless/setDelivery', value);
				}
			},
            firstNameValidated() {
			    if(!this.useAlternateAddress){
			        return true;
				}

                if (this.delivery.information.firstname) {
                    return this.delivery.information.firstname !== '' && this.delivery.information.firstname.length > 0;
                }

                return false;
            },
            lastNameValidated() {
                if(!this.useAlternateAddress){
                    return true;
                }

                if (this.delivery.information.lastname) {
                    return this.delivery.information.lastname !== '' && this.delivery.information.lastname.length > 0;
                }

                return false;
            },
            addressValidated() {
                if(!this.useAlternateAddress){
                    return true;
                }

                if (this.delivery.information.address) {
                    var addressRegex = this.delivery.information.address.match(/([A-Z])\w*\s+([0-9])+/gi);

                    return this.delivery.information.address !== '' && (addressRegex instanceof Array && addressRegex.length > 0);
                }

                return false;
            },
            zipCodeValidated() {
                if(!this.useAlternateAddress){
                    return true;
                }

                if (this.delivery.information.zipcode) {

                    var zipcodeRegex = String(this.delivery.information.zipcode).match(/^([0-9]){4,4}/gi);

                    return this.delivery.information.zipcode !== '' && (zipcodeRegex instanceof Array && zipcodeRegex.length > 0 && zipcodeRegex.length < 5);
                }

                return false;
            },
            cityValidated() {
                if(!this.useAlternateAddress){
                    return true;
                }

                return this.delivery.information.city !== '';
            },
            emailValidated() {
                if(!this.useAlternateAddress){
                    return true;
                }

                if (this.delivery.information.email) {
                    var emailRegex = this.delivery.information.email.match(/^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i);
                    return this.delivery.information.email !== '' && (emailRegex instanceof Array && emailRegex.length > 0);
                }

                return false;
            },
            phoneValidated() {
                if(!this.useAlternateAddress){
                    return true;
                }

                if (this.delivery.information.phone) {
                    var phoneRegex = String(this.delivery.information.phone).match(/^([0-9]){8,8}/gi);

                    return this.delivery.information.phone !== '' && (phoneRegex instanceof Array && phoneRegex.length > 0);
                }
            },
			timeValidated(){
				return this.deliveryTime !== null && this.deliveryTime !== undefined;
			},
            dateValidated(){
                return this.deliveryDate !== null;
            },
            allInformationValidated() {
                return this.firstNameValidated
                    && this.lastNameValidated
                    && this.addressValidated
                    && this.zipCodeValidated
                    && this.cityValidated
                    && this.emailValidated
                    && this.phoneValidated
					&& this.dateValidated
					&& this.timeValidated
                    && this.canDeliver
            },
            hasEnteredFirstName() {
                return this.fieldHasBeenEntered('firstname');
            },
            hasEnteredLastName() {
                return this.fieldHasBeenEntered('lastname');
            },
            hasEnteredAddress() {
                return this.fieldHasBeenEntered('address');
            },
            hasEnteredZip() {
                return this.fieldHasBeenEntered('zip');
            },
            hasEnteredCity() {
                return this.fieldHasBeenEntered('city');
            },
            hasEnteredEmail() {
                return this.fieldHasBeenEntered('email');
            },
            hasEnteredPhone() {
                return this.fieldHasBeenEntered('phone');
            },
            hasEnteredTime() {
                return this.fieldHasBeenEntered('time');
            },
            hasEnteredDate() {
                return this.fieldHasBeenEntered('date');
            },
			deliveryTimes(){
                if( moment(this.deliveryDate).isSame(
                    moment().endOf("year").subtract(8,'days')
                        .set('hour', 0)
                        .set('minute', 0)
                        .set('second', 0)
                        .set('millisecond', 0)
                        .set().format('YYYY-MM-DD HH:mm:ss'))){
                    return [
                        '10:30',
                        '11:30',
                    ]
                }

				if (moment(this.deliveryDate).isoWeekday() === 7){
				    return [
                        '10:30',
                        '11:30',
                        '12:30',
                        '15:30',
					]
				}

			    return [
			        '10:30',
					'11:30',
					'12:30',
					'15:30',
					'16:30',
				]
			},
			canGetDeliveryFrom(){
			    return moment().add(8,'d').format('YYYY-MM-DD');
			},
			deliverToZipcode(){
			    if(this.useAlternateAddress && this.delivery.information.zipcode && String(this.delivery.information.zipcode).length == 4){
			        return this.delivery.information.zipcode;
				}
				return this.order.information.zipcode;
			},
			lockTimeSelector(){
				return false;
			},
			endDate(){
			    return moment().add(2, 'y').format('YYYY-MM-DD');
			},
            canDeliver(){
               return this.zipcodes.includes(parseInt(this.deliverToZipcode)) || !this.delivery.with_delivery;
            }
		},
		asyncComputed:{

          	async deliveryFee(){
                if(this.delivery.with_delivery && this.deliveryTime && this.deliveryDate && this.deliverToZipcode){
					const response = await  axios.post(`/api/public/delivery/price`, {
                        date: moment(`${this.deliveryDate} ${this.deliveryTime}`).format('YYYY-MM-DD HH:mm:ss'),
                        zipcode: this.deliverToZipcode
                    });

					this.delivery.delivery_fee = response.data.data.price;

					return response.data.data.price;
                }else{
                    this.delivery.delivery_fee = 0;
                }

                return 0;

            }
		},
		methods:{
            submitDelivery(){
				this.delivery.deliver_at = moment(`${this.deliveryDate} ${this.deliveryTime}`).format('YYYY-MM-DD HH:mm:ss');
                this.$store.dispatch('productless/completedDelivery');
                this.$router.push({
                    name:'make-productless-order.order.approve'
                });
			},
            fieldHasBeenEntered(fieldName) {
                return this.enteredFields.indexOf(fieldName) > -1
            },
            enteredField(fieldName) {
                if (!this.fieldHasBeenEntered(fieldName)) {
                    return this.enteredFields.push(fieldName);
                }

                if(fieldName === 'zipcode'){
                    this.fetchDeliveryPrice();
				}
            },
            /*updateInformationWithCity() {
                this.enteredField('city');
                if(this.city != this.delivery.information.city){
                    this.delivery.information.city = this.city;
                }
            },
            convertZipcodeToCity(){
                this.getCityForZipCode(this.delivery.information.zipcode).then(city => {
                    this.city= city;
                    this.delivery.information.city = city;
                }).catch(error => {
                    console.log(error);
                });
            },*/
			closeAndResetAlternateAddress(){
                this.useAlternateAddress = false;
                this.delivery.information = {
                    firstname:'',
                    lastname:'',
                    address:'',
                    zipcode:'',
                    city:'',
                    email:'',
                    phone:''
                };
                this.city = '';
			},
            setDeliveryDate(val){
                if(val == ''){
                    return;
				}
				this.deliveryTime = null;

                this.datePickerDate = val;
                this.deliveryDate = val;
                this.showDatePickerModal = false;
            },
            datePickerReset(){
                this.showDatePickerModal = false;
                this.datePickerDate = null;
            },
			showDatePicker(){
				this.datePickerReset();
                this.showDatePickerModal = true;
			},
		},
        beforeRouteEnter (to, from, next) {
            next(vm => {
                if(vm.order){
                    if(vm.order.delivery.information.address){
                        vm.useAlternateAddress = true;
                    }

                    if (vm.order.delivery.information.city) {
                        vm.city = vm.order.delivery.information.city;
                    }

                    if(vm.order.delivery.deliver_at){
                        let delivery = moment(vm.order.delivery.deliver_at, 'YYYY-MM-DD HH:mm:ss');
                        vm.deliveryTime = delivery.format('HH:mm');
                        vm.deliveryDate = delivery.format('YYYY-MM-DD');
                    }
                }
            })
        }
    }
</script>

<style scoped>

</style>
